import { Injectable } from '@angular/core';
import { CreditNoteEnhancedApiService } from '@cms/apis';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { exhaustMap, map } from 'rxjs';
import { CreditNoteAction } from '../actions';
import { FnWithCompany, WithCompany } from '@cms/backgrounds/switch-company';

@Injectable()
export class CreditNoteEffect {
  loadItem$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(CreditNoteAction.loadItem),
      exhaustMap(action => {
        return this.fetch(action.id).pipe(map(item => CreditNoteAction.loadItemSuccess({ item })));
      })
    );
  });

  @FnWithCompany()
  fetch(id: number, @WithCompany() option: Record<string, any> = {}) {
    return this._apiService.get(id, option);
  }

  constructor(private _apiService: CreditNoteEnhancedApiService, private _actions$: Actions, private _store: Store) {}
}
